<template>
  <div>
    <v-toolbar dark color="blue darken-3" flat>
      <v-toolbar-title>Прикрепленные события</v-toolbar-title>
      <v-spacer />
      <new-history-element @submit="appendDate" />
    </v-toolbar>
    <v-expansion-panels v-if="children.length">
      <v-expansion-panel v-for="(item, itemK) in children" :key="itemK">
        <v-expansion-panel-header>
          {{ item.date }}
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            hide-default-footer
            :items="item.items"
          >
            <template #item.name="{ item }">
              <router-link :to="{ name: 'layers-item', params: { id: item.id } }">
                {{ item.name }}
              </router-link>
            </template>
            <template #item.type="{ item }">
              {{ eventTypes[item.type] }}
            </template>
            <template #item.actions="{ item }">
              <v-btn
                color="red"
                dark
                x-small
                @click="$dialog.show('event-remove-confirmation', { itemId: item.id })"
              >
                Удалить
              </v-btn>
            </template>
          </v-data-table>
          <new-layer-dialog
            v-permission="['layer-create']"
            :parent-id="single.id"
            :except="['history']"
            :lock-object-type="single.objectType"
            :lock-category="single.category ? single.category.id : 'locked'"
            :happened-at="item.date"
            class="mt-2"
          />
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-card v-else>
      <v-card-text>Нет прикрепленных событий</v-card-text>
    </v-card>

    <remove-confirmation
      name="event-remove-confirmation"
      title="Вы действительно желаете удалить событие?"
      @confirmed="onEventRemove"
    />
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import RemoveConfirmation from '@/components/dialogs/confirmations/RemoveConfirmation.vue';
import NewHistoryElement from '@/views/events/components/NewHistoryElement.vue';
import NewLayerDialog from '@/views/layers/components/NewLayerDialog.vue';

export default {
  name: 'event-history-elements',
  components: {
    NewLayerDialog,
    RemoveConfirmation,
    NewHistoryElement,
  },
  props: {
    single: {
      type: Object,
      required: true,
    },
    eventTypes: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { value: 'name', text: 'Название события', sortable: false },
      { value: 'type', text: 'Тип события', sortable: false },
      { value: 'actions' },
    ],
    items: [
      { type: 'Маркер', name: 'Тестовое событие' },
    ],
    children: [],
  }),
  watch: {
    // eslint-disable-next-line func-names
    'single.children': function () {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions('layer-objects', ['remove']),

    init() {
      if (this.single.children) {
        this.children = [];
        this.single.children.forEach(_ => {
          let formatted = 'Без даты';
          if (_.happenedAt) {
            formatted = moment(_.happenedAt).format('DD.MM.YYYY HH:mm');
          }
          const index = this.children.findIndex(__ => __.date === formatted);
          if (index !== -1) {
            this.children[index].items.push(_);
          } else {
            this.children.push({
              date: formatted,
              items: [_],
            });
          }
        });
      }
    },

    appendDate({ date, time }) {
      const formatted = moment(`${date}T${time}`).format('DD.MM.YYYY HH:mm');
      if (this.children.map(_ => _.date).includes(formatted)) return;
      this.children.push({ date: formatted, items: [] });
    },
    async onEventRemove(id) {
      await this.remove(id);
      this.$emit('onChildRemove');
    },
  },
};
</script>

<style scoped>

</style>
